import * as R from 'ramda';
import React, { useEffect, useState } from 'react';
// helpers/constants
import * as G from '../helpers';
import * as GC from '../constants';
// utilities
import { sendRequest } from '../utilities/http';
import endpointsMap from '../utilities/endpoints';
//////////////////////////////////////////////////

const useAsyncAvailableDocumentTypes = (branchGuid) => {
  const [documents, setDocuments] = useState({ availableDocumentTypes: [], availableDocumentTypesOptionsAsync: [] });

  useEffect(() => {
    const getAvailableDocumentTypesRequest = async () => {
      const branchGuidToUse = G.ifElse(
        G.isNotNilAndNotEmpty(branchGuid),
        branchGuid,
        G.getAmousCurrentBranchGuidFromWindow(),
      );

      const options = { params: { [GC.FIELD_BRANCH_GUID]: branchGuidToUse } };

      const res = await sendRequest('get', endpointsMap.availableDocumentTypes, options);
      const { data, status } = res;

      if (G.isResponseSuccess(status)) {
        const list = R.or(data, []);

        setDocuments({
          availableDocumentTypes: list,
          availableDocumentTypesOptionsAsync: G.getOptionsFromConfigValueByParentGuidOrGuid(list),
        });
      } else {
        G.handleFailResponseSimple(
          res,
          false,
          'withAsyncAvailableDocumentTypes -> getAvailableDocumentTypesRequest',
        );
      }
    };

    getAvailableDocumentTypesRequest();
  }, []);

  return documents;
};

export const withAsyncAvailableDocumentTypes = (Component) => (props) => {
  const { branchGuid } = props;

  const documents = useAsyncAvailableDocumentTypes(branchGuid);

  return <Component {...props} {...documents} />;
};
